import type { LibraryItem } from '@/modules/Library/libraryStore'
import type { ExtensionOrDocument } from '@/modules/Workspaces/KnowledgeHub/Files/library-item'
import { invariant } from '@/shared/utils/typeAssertions'
import { inject, provide, type InjectionKey, type MaybeRefOrGetter, type Ref } from 'vue'

export type FileTableContext = {
  isSelected: (id: string) => boolean
  setSelected: (id: string, state: boolean) => void
  filterOwners: Ref<string[]>
  filterFileType: Ref<ExtensionOrDocument[]>
  /** Used to filter only files, or only documents */
  filterItemType?: MaybeRefOrGetter<LibraryItem['type'] | undefined>
}

const fileTableContextToken = Symbol('selection') as InjectionKey<FileTableContext>

export function useFileTableContext() {
  const injection = inject(fileTableContextToken)
  invariant(injection, 'Selection context not provided')
  return injection
}

export function provideFileTableContext(value: FileTableContext) {
  provide(fileTableContextToken, value)
}
